export default __webpack_public_path__ + "static/media/7_1.b0226f39.png";